import { reactive } from 'vue';

export const criarPlaLeiteItem = () => {
  return reactive({
    id: 0,
    idplaleite: 0,
    dtrecebimento: '',
    hrrecebimento: '',
    placa_veiculo: '',
    nrotanque: 0,
    qtd: 0,
    lote: '',
    temperatura: 0,
    vlalizarol: 0,
    vlacidez: 0,
    vldensidade: 0,
    ckdestino_lc: '',
    fosfatase: '',
    peroxidase: '',
    nmfornecedor: '',
    nmresponsavel: '',
    idlogin: 0,
    idusuario: 0
  });
};